@use "../../../../shared/scss" as *;

:host {
  display: block;
  inline-size: 100%;

  .item-highlight {
    display: none;
  }

  phn-nd-side-drawer-item {
    margin-block-start: p-px-to-rem(16px);

    &.models {
      margin-block-start: p-px-to-rem(8px);

      @include pds-media-query-min("xxl") {
        margin-block-start: p-px-to-rem(16px);
      }
    }

    &:first-of-type {
      margin-block-start: 0;
    }
  }
}
